var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "has-logo": _vm.showLogo } },
    [
      _c("logo", {
        attrs: { collapse: _vm.isCollapse },
        on: { toIndex: _vm.toIndex },
      }),
      _vm._v(" "),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper" } },
        [
          _c(
            "el-menu",
            {
              staticClass: "scrollbarBox",
              attrs: {
                "default-active": _vm.currPath,
                collapse: _vm.isCollapse,
                "background-color": _vm.variables.menuBg,
                "text-color": _vm.variables.menuText,
                "unique-opened": false,
                "active-text-color": _vm.variables.menuActiveText,
              },
            },
            _vm._l(_vm.permissionRoutes, function (route) {
              return _vm.permissionRoutes
                ? _c("sidebar-item", {
                    key: route.path,
                    attrs: { item: route, "base-path": route.path },
                    on: { retParentObj: _vm.getParentObj },
                  })
                : _vm._e()
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }